//src/pages/TikpagExperience/TikpagExperienceCategorias.jsx

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

import {
  Edit3,
  Layers3,
  Plus,
  RefreshCcw,
  Search,
  Tags,
  Trash2,
  X
} from "lucide-react";

import axios from "../../axiosConfig";
import "./TikpagExperienceCategorias.css";

const FORM_INICIAL = {
  id: null,
  nome: "",
  icone: "",
  ativo: true
};

export default function TikpagExperienceCategorias() {
  const [categorias, setCategorias] =
    useState([]);

  const [busca, setBusca] =
    useState("");

  const [statusFiltro, setStatusFiltro] =
    useState("");

  const [formulario, setFormulario] =
    useState(FORM_INICIAL);

  const [modalAberto, setModalAberto] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const [salvando, setSalvando] =
    useState(false);

  const [erro, setErro] =
    useState("");

  const [sucesso, setSucesso] =
    useState("");

  const carregarCategorias =
    useCallback(async () => {
      setLoading(true);
      setErro("");

      try {
        const resposta = await axios.get(
          "/admin/experience/categorias"
        );

        setCategorias(
          Array.isArray(
            resposta.data?.categorias
          )
            ? resposta.data.categorias
            : []
        );
      } catch (err) {
        console.error(
          "Erro ao carregar categorias Experience:",
          err
        );

        setErro(
          err.response?.data?.error ||
            "Não foi possível carregar as categorias."
        );
      } finally {
        setLoading(false);
      }
    }, []);

  useEffect(() => {
    carregarCategorias();
  }, [carregarCategorias]);

  const categoriasFiltradas =
    useMemo(() => {
      const termo =
        busca.trim().toLowerCase();

      return categorias.filter(
        (categoria) => {
          const correspondeBusca =
            !termo ||
            [
              categoria.nome,
              categoria.icone
            ]
              .filter(Boolean)
              .join(" ")
              .toLowerCase()
              .includes(termo);

          const correspondeStatus =
            !statusFiltro ||
            (
              statusFiltro === "ATIVA"
                ? Boolean(
                    categoria.ativo
                  )
                : !Boolean(
                    categoria.ativo
                  )
            );

          return (
            correspondeBusca &&
            correspondeStatus
          );
        }
      );
    }, [
      categorias,
      busca,
      statusFiltro
    ]);

  const abrirNovaCategoria = () => {
    setFormulario(FORM_INICIAL);
    setErro("");
    setSucesso("");
    setModalAberto(true);
  };

  const abrirEdicao = (categoria) => {
    setFormulario({
      id: Number(categoria.id),
      nome: categoria.nome || "",
      icone: categoria.icone || "",
      ativo: Boolean(categoria.ativo)
    });

    setErro("");
    setSucesso("");
    setModalAberto(true);
  };

  const fecharModal = () => {
    if (salvando) return;

    setModalAberto(false);
    setFormulario(FORM_INICIAL);
  };

  const atualizarCampo = (
    campo,
    valor
  ) => {
    setFormulario((atual) => ({
      ...atual,
      [campo]: valor
    }));
  };

  const salvarCategoria = async (
    event
  ) => {
    event.preventDefault();

    if (!formulario.nome.trim()) {
      setErro(
        "Informe o nome da categoria."
      );
      return;
    }

    setSalvando(true);
    setErro("");
    setSucesso("");

    try {
      const payload = {
        nome:
          formulario.nome.trim(),

        icone:
          formulario.icone.trim(),

        ativo:
          Boolean(formulario.ativo)
      };

      if (formulario.id) {
        await axios.put(
          `/admin/experience/categorias/${formulario.id}`,
          payload
        );

        setSucesso(
          "Categoria atualizada com sucesso."
        );
      } else {
        await axios.post(
          "/admin/experience/categorias",
          payload
        );

        setSucesso(
          "Categoria criada com sucesso."
        );
      }

      setModalAberto(false);
      setFormulario(FORM_INICIAL);

      await carregarCategorias();
    } catch (err) {
      console.error(
        "Erro ao salvar categoria Experience:",
        err
      );

      setErro(
        err.response?.data?.error ||
          "Não foi possível salvar a categoria."
      );
    } finally {
      setSalvando(false);
    }
  };

  const excluirCategoria = async (
    categoria
  ) => {
    const confirmou =
      window.confirm(
        `Excluir a categoria "${categoria.nome}"?`
      );

    if (!confirmou) return;

    setErro("");
    setSucesso("");

    try {
      await axios.delete(
        `/admin/experience/categorias/${categoria.id}`
      );

      setSucesso(
        "Categoria excluída com sucesso."
      );

      await carregarCategorias();
    } catch (err) {
      console.error(
        "Erro ao excluir categoria Experience:",
        err
      );

      setErro(
        err.response?.data?.error ||
          "Não foi possível excluir a categoria."
      );
    }
  };

  const totalExperiencias =
    categorias.reduce(
      (total, categoria) =>
        total +
        Number(
          categoria
            .quantidade_experiencias || 0
        ),
      0
    );

  return (
    <div className="experienceCategorias-page">
      <header className="experienceCategorias-header">
        <div>
          <span className="experienceCategorias-kicker">
            Tikpag Experience
          </span>

          <h1>Categorias</h1>

          <p>
            Organize as experiências por
            gastronomia, lazer, música, presentes
            e outras áreas.
          </p>
        </div>

        <button
          type="button"
          className="experienceCategorias-primaryButton"
          onClick={abrirNovaCategoria}
        >
          <Plus size={16} />
          Nova categoria
        </button>
      </header>

      {erro && (
        <div className="experienceCategorias-alert erro">
          {erro}
        </div>
      )}

      {sucesso && (
        <div className="experienceCategorias-alert sucesso">
          {sucesso}
        </div>
      )}

      <section className="experienceCategorias-summary">
        <article className="experienceCategorias-summaryCard">
          <div className="experienceCategorias-summaryIcon">
            <Tags size={20} />
          </div>

          <div>
            <span>
              Categorias cadastradas
            </span>

            <strong>
              {categorias.length}
            </strong>
          </div>
        </article>

        <article className="experienceCategorias-summaryCard">
          <div className="experienceCategorias-summaryIcon">
            <Layers3 size={20} />
          </div>

          <div>
            <span>
              Experiências distribuídas
            </span>

            <strong>
              {totalExperiencias}
            </strong>
          </div>
        </article>

        <article className="experienceCategorias-summaryCard">
          <div className="experienceCategorias-summaryIcon">
            <Tags size={20} />
          </div>

          <div>
            <span>
              Categorias ativas
            </span>

            <strong>
              {
                categorias.filter(
                  (categoria) =>
                    Boolean(
                      categoria.ativo
                    )
                ).length
              }
            </strong>
          </div>
        </article>
      </section>

      <section className="experienceCategorias-panel">
        <div className="experienceCategorias-toolbar">
          <div className="experienceCategorias-search">
            <Search size={16} />

            <input
              value={busca}
              onChange={(event) =>
                setBusca(
                  event.target.value
                )
              }
              placeholder="Buscar categoria por nome ou ícone"
            />
          </div>

          <div className="experienceCategorias-filters">
            <select
              value={statusFiltro}
              onChange={(event) =>
                setStatusFiltro(
                  event.target.value
                )
              }
            >
              <option value="">
                Todas
              </option>

              <option value="ATIVA">
                Ativas
              </option>

              <option value="INATIVA">
                Inativas
              </option>
            </select>

            <button
              type="button"
              className="experienceCategorias-secondaryButton"
              onClick={
                carregarCategorias
              }
              disabled={loading}
            >
              <RefreshCcw
                size={16}
                className={
                  loading
                    ? "experienceCategorias-spin"
                    : ""
                }
              />

              Atualizar
            </button>
          </div>
        </div>

        <div className="experienceCategorias-list">
          {categoriasFiltradas.map(
            (categoria) => (
              <article
                className="experienceCategorias-card"
                key={categoria.id}
              >
                <div className="experienceCategorias-main">
                  <div className="experienceCategorias-identity">
                    <div className="experienceCategorias-icon">
                      <Tags size={20} />
                    </div>

                    <div>
                      <h2>
                        {categoria.nome}
                      </h2>

                      <p>
                        {categoria.icone
                          ? `Ícone: ${categoria.icone}`
                          : "Sem ícone definido"}
                      </p>
                    </div>
                  </div>

                  <div className="experienceCategorias-metric">
                    <span>
                      Experiências
                    </span>

                    <strong>
                      {Number(
                        categoria
                          .quantidade_experiencias ||
                          0
                      )}
                    </strong>
                  </div>

                  <div className="experienceCategorias-metric">
                    <span>Status</span>

                    <strong>
                      {categoria.ativo
                        ? "Ativa"
                        : "Inativa"}
                    </strong>
                  </div>

                  <span
                    className={`experienceCategorias-status ${
                      categoria.ativo
                        ? "ativa"
                        : "inativa"
                    }`}
                  >
                    {categoria.ativo
                      ? "Disponível"
                      : "Inativa"}
                  </span>

                  <div className="experienceCategorias-actions">
                    <button
                      type="button"
                      className="experienceCategorias-editButton"
                      onClick={() =>
                        abrirEdicao(
                          categoria
                        )
                      }
                    >
                      <Edit3 size={15} />
                      Editar
                    </button>

                    <button
                      type="button"
                      className="experienceCategorias-deleteButton"
                      onClick={() =>
                        excluirCategoria(
                          categoria
                        )
                      }
                    >
                      <Trash2 size={15} />
                    </button>
                  </div>
                </div>
              </article>
            )
          )}

          {!loading &&
            !categoriasFiltradas.length && (
              <div className="experienceCategorias-empty">
                Nenhuma categoria encontrada.
              </div>
            )}

          {loading && (
            <div className="experienceCategorias-empty">
              Carregando categorias...
            </div>
          )}
        </div>
      </section>

      {modalAberto && (
        <div
          className="experienceCategorias-modalOverlay"
          onMouseDown={(event) => {
            if (
              event.target ===
              event.currentTarget
            ) {
              fecharModal();
            }
          }}
        >
          <form
            className="experienceCategorias-modal"
            onSubmit={salvarCategoria}
          >
            <div className="experienceCategorias-modalHeader">
              <div>
                <span className="experienceCategorias-kicker">
                  Tikpag Experience
                </span>

                <h2>
                  {formulario.id
                    ? "Editar categoria"
                    : "Nova categoria"}
                </h2>
              </div>

              <button
                type="button"
                className="experienceCategorias-closeButton"
                onClick={fecharModal}
              >
                <X size={19} />
              </button>
            </div>

            <div className="experienceCategorias-modalBody">
              <div className="experienceCategorias-formGrid">
                <label className="experienceCategorias-field">
                  <span>
                    Nome da categoria
                  </span>

                  <input
                    value={
                      formulario.nome
                    }
                    onChange={(event) =>
                      atualizarCampo(
                        "nome",
                        event.target.value
                      )
                    }
                    placeholder="Ex.: Gastronomia"
                    autoFocus
                  />
                </label>

                <label className="experienceCategorias-field">
                  <span>Ícone</span>

                  <input
                    value={
                      formulario.icone
                    }
                    onChange={(event) =>
                      atualizarCampo(
                        "icone",
                        event.target.value
                      )
                    }
                    placeholder="Ex.: utensílios, música, presente"
                  />
                </label>

                <label className="experienceCategorias-check full">
                  <input
                    type="checkbox"
                    checked={
                      formulario.ativo
                    }
                    onChange={(event) =>
                      atualizarCampo(
                        "ativo",
                        event.target.checked
                      )
                    }
                  />

                  <span>
                    <strong>
                      Categoria ativa
                    </strong>

                    <small>
                      Categorias inativas ficam
                      indisponíveis para novos
                      cadastros de experiências.
                    </small>
                  </span>
                </label>
              </div>
            </div>

            <div className="experienceCategorias-modalFooter">
              <button
                type="button"
                className="experienceCategorias-secondaryButton"
                onClick={fecharModal}
                disabled={salvando}
              >
                Cancelar
              </button>

              <button
                type="submit"
                className="experienceCategorias-primaryButton"
                disabled={salvando}
              >
                {salvando ? (
                  <RefreshCcw
                    size={16}
                    className="experienceCategorias-spin"
                  />
                ) : (
                  <Tags size={16} />
                )}

                {formulario.id
                  ? "Salvar alterações"
                  : "Criar categoria"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}